import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { api } from "../../lib/chalkApi";
import { ChalkCard, DarkHeader, SectionTitle } from "../../components/chalk/primitives";
import { BackButton } from "./AdminBilling";

export default function AdminEmails() {
  const navigate = useNavigate();
  const [data, setData] = useState({ emails: [], templates: {} });
  const [active, setActive] = useState(null);

  useEffect(() => { api.adminEmails().then(setData); }, []);

  return (
    <>
      <DarkHeader eyebrow="Admin" title="Email preview" subtitle="Every template, viewable in your browser." right={<BackButton onClick={() => navigate(-1)} />} />
      <div style={{ padding: "0 18px 24px" }}>
        <SectionTitle label="Templates" />
        {Object.entries(data.templates || {}).map(([key, tpl]) => (
          <ChalkCard key={key} style={{ marginTop: 8 }} onClick={() => setActive({ key, tpl })} data-testid={`template-${key}`}>
            <div style={{ fontSize: 14, fontWeight: 500, color: "var(--chalk-board)" }}>{key}</div>
            <div style={{ fontSize: 12, color: "var(--chalk-muted)", marginTop: 4 }}>{tpl.subject}</div>
          </ChalkCard>
        ))}

        <SectionTitle label="Recent sends" />
        {data.emails.length === 0 ? <div style={{ marginTop: 8, fontSize: 13, color: "var(--chalk-muted)" }}>No emails yet.</div> :
          data.emails.slice(0, 20).map((e) => (
            <ChalkCard key={e.id} style={{ marginTop: 8 }}>
              <div style={{ fontSize: 13, color: "var(--chalk-board)", fontWeight: 500 }}>{e.rendered_subject}</div>
              <div style={{ fontSize: 12, color: "var(--chalk-muted)", marginTop: 4 }}>{e.template} · {e.status}</div>
              <div style={{ fontSize: 13, color: "var(--chalk-board)", marginTop: 6 }}>{e.rendered_body}</div>
            </ChalkCard>
          ))
        }

        {active && (
          <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.4)", zIndex: 50 }} onClick={() => setActive(null)}>
            <div onClick={(e) => e.stopPropagation()} style={{ background: "#fff", maxWidth: 480, margin: "60px auto", borderRadius: 14, padding: 18 }}>
              <div style={{ background: "var(--chalk-board)", color: "var(--chalk-white)", padding: 18, borderRadius: 10, marginBottom: 14 }}>
                <div style={{ fontSize: 16, fontWeight: 500 }}>{active.tpl.subject}</div>
              </div>
              <div style={{ fontSize: 14, color: "var(--chalk-board)", lineHeight: 1.5 }}>{active.tpl.body}</div>
              <button className="chalk-btn-ghost" style={{ marginTop: 16 }} onClick={() => setActive(null)}>Close</button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
